import Modal from 'react-bootstrap-modal';
import React, {Component} from 'react';
import Button from 'elements/CustomButton/CustomButton.jsx';
import Moment from 'react-moment';


class SubmissionModal extends Component {
    state = {
        open: false,
        imgs: {},
    };

    fields = [
        ['time', 'Submitted'],
        ['studentName', 'Student Name'],
        ['purchaserName', 'Purchaser Name'],
        ['email', 'Purchaser E-Mail'],
        ['paid', 'Paid'],
        ['latefee', 'Late Fee'],
        ['size', 'Size'],
        ['text', 'Message']
    ];

    fetchImageUrls() {
        // Get URLs for images
        this.props.submission.images.forEach(img => {
            this.props.storage.child(img).getDownloadURL()
                .then(url => {
                    let imgs = this.state.imgs;
                    imgs[img] = url;

                    this.setState({imgs: imgs});
                });
        });
    }

    render() {
        let closeModal = () => this.setState({open: false});

        return (
            <Button bsStyle="primary" fill
                    onClick={() => {
                        this.setState({open: true});
                        this.fetchImageUrls();
                    }}>
                <i className="pe-7s-look" alt="View"/>
                <Modal show={this.state.open}
                       onHide={closeModal}
                       aria-labelledby="ModalHeader">
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader'>Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="table">
                            <tbody>
                            {
                                this.fields.map(pair => {
                                    if (false === (pair[0] in this.props.submission))
                                        return;
                                    if (pair[0] === 'paid' && this.props.submission.finalized === false)
                                        return;

                                    if (pair[0] === 'time')
                                        return (
                                            <tr key={pair[0]}>
                                                <td>
                                                    <b>{pair[1]}</b>
                                                </td>
                                                <td>
                                                    <Moment unix
                                                            tz={this.props.timezone}
                                                            format="MMM D, h:mma">
                                                        {this.props.submission[pair[0]]}
                                                    </Moment>
                                                </td>
                                            </tr>
                                        );

                                    return (
                                        <tr key={pair[0]}>
                                            <td>
                                                <b>{pair[1]}</b>
                                            </td>
                                            <td>
                                                {(pair[0] === 'paid' || pair[0] === 'latefee') ? '$' : ''}
                                                {this.props.submission[pair[0]]}
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            <tr>
                                <td><b>Photos</b></td>
                                <td>
                                    {Object.keys(this.state.imgs).map(img_key => {
                                        return (
                                            <div className="col" key={img_key}>
                                                <img width="200"
                                                     src={this.state.imgs[img_key]}/>
                                                <div>
                                                    {(!(this.props.submission['specialInstructions'] === undefined) &&
                                                        !(this.props.submission.specialInstructions[img_key] === undefined))
                                                        ? this.props.submission.specialInstructions[img_key] : ''}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.Dismiss className='btn btn-default'>Close</Modal.Dismiss>
                    </Modal.Footer>
                </Modal>
            </Button>
        )
    }
}

export default SubmissionModal;
// ReactDOM.render(<ModalExample />, document.body);



// WEBPACK FOOTER //
// ./src/components/SubmissionModal/SubmissionModal.jsx